export const TransactionAttachmentsAcceptedFileTypes = [
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  'image/tiff',
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/gif',
];

/**
 * Classifies the transaction a document is attached to. Classic reads this
 * value as Reckon.CashbookCore.Contracts.QueryModel.TransactionDocuments
 * .TransactionDocumentType, which is what TransactionDocumentController casts
 * its transactionType parameter to.
 *
 * Note there is a second TransactionDocumentType enum in
 * Reckon.ServiceAbstractionLayer that numbers the same types differently
 * (purchase orders 9, recurring transactions 10). It is not the one this
 * endpoint reads.
 *
 * RECEIPTS is ExpenseClaims in the backend enum; the name here predates this
 * constant and is kept so the value stays put.
 */
export const TransactionDocumentType = {
  UNKNOWN: '0',
  BILLS: '1',
  PAYMENTS: '2',
  RECEIPTS: '3',
  INVOICES: '4',
  CHARGEABLE_ITEMS: '5',
  PURCHASE_ORDERS: '6',
  RECURRING_TRANSACTIONS: '7',
  LEAVE_REQUEST: '8',
} as const;
